// import React from 'react';
// import Sidebar from './Sidebar';
// import Topbar from './TopBar';
// import { Outlet } from 'react-router-dom';

// const AdminLayout = () => {
//   return (
//     <div className="app-container d-flex">
//       <div className="flex-grow-1">
//         {/* <Topbar /> */}
//         {/* <div className="container mt-4">
//           <Outlet />
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;

// src/layouts/AdminLayout.js
import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './TopBar';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';
import '../../assets/css/Sidebar.css'; // Make sure this has layout styles

const AdminLayout = () => {
  return (
    <>
      <Topbar />

      <div className="app-container" style={{ display: 'flex' }}>

      <Navbar />
               
          <div className="w-100 mw-100 " style={{ overflowY:"hidden"}}>


            {/* <Sidebar /> */}

            <Outlet />
          </div>
        </div>
    </>
  );
};

export default AdminLayout;
